import { gsap } from 'gsap';

export const PanelsInteraction = (function () {
	'use strict';

	var panels = document.querySelectorAll('.panels .panel');

	function init() {
		for (var i = 0; i < panels.length; i++) {
			// console.log(panels[i].classList);
			// setTimeout(function() {
				panels[i].addEventListener('mouseenter', function() {
					gsap.to(panels, {
						duration: 0.6,
						width: '16.666%'
					});
					gsap.to(this, {
						duration: 0.6,
						width: '50%'
					});
					// TweenLite.to(panels, 0.6, { width: '16.666%' });
					// TweenLite.to(this, 0.6, { width: '50%' });
					this.classList.add('active');
				});

				panels[i].addEventListener('mouseleave', function() {
					this.classList.remove('active');
					// TweenLite.to(panels, 0.6, { width: '25%' });
					gsap.to(panels, {
						duration: 0.6,
						width: '25%'
					});
					
				});
			// }, 500);
		}
	}

	return {
		init: init,
	};
})();
